export const loginPolicies = {
    ANY_SSO: 'any_sso',
    GOOGLE: 'google',
    MICROSOFT: 'microsoft',
    TFA: 'tfa'
};

export const loginTypes = {
    GOOGLE: 0,
    MICROSOFT: 1,
    TFA: 2
};

export const isSSORestricted = loginPolicy => {
    return [loginPolicies.ANY_SSO, loginPolicies.GOOGLE, loginPolicies.MICROSOFT].includes(loginPolicy);
}

export const canLoginWithGoogleSSO = loginPolicy => {
    return [loginPolicies.ANY_SSO, loginPolicies.GOOGLE].includes(loginPolicy);
}

export const canLoginWithMicrosoftSSO = loginPolicy => {
    return [loginPolicies.ANY_SSO, loginPolicies.MICROSOFT].includes(loginPolicy);
}
